<!-- HEADER & STEPPER -->
<div class="mb-6 px-3">
  <div class="w-fit rounded-2xl border border-gray-300 bg-gradient-to-r from-gray-50 to-white px-5 py-3 mb-6">
    <div class="border-l-4 border-gray-800 pl-4">
      <p class="text-xs font-semibold uppercase tracking-[0.18em] text-gray-500">
        Social Posts Section
      </p>
      <h2 class="mt-1 text-2xl font-bold leading-tight tracking-tight text-gray-900">
        Upload Bulk
      </h2>
    </div>
  </div>

  <!-- Stepper -->
  <div class="w-full 2xl:w-3/4">
    <app-stepper-grid></app-stepper-grid>
  </div>
</div>

<!-- CONTENT WRAPPER -->
<div class="bg-gray-50 px-3 pb-10 min-h-screen pt-6">
  <!-- Content Grid -->
  <div class="grid grid-cols-12 gap-6 items-stretch">
    <div class="col-span-12 2xl:col-span-9">
      <div class="bg-white rounded-3xl border border-gray-200 p-6">
        <mat-table [dataSource]="dataSource" multiTemplateDataRows
          class="mat-elevation-z0 !w-full !inline-table table-alternate">

          <!-- <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef class="text-left font-semibold">ID</th>
            <td mat-cell *matCellDef="let element">{{ element.id }}</td>
          </ng-container> -->

          <ng-container matColumnDef="file_name">
            <th mat-header-cell *matHeaderCellDef class="text-left font-semibold">File Name</th>
            <!-- <td mat-cell *matCellDef="let element">{{ element.file_name }}</td> -->
           <td mat-cell *matCellDef="let element" class="text-gray-600">{{ element.file_name }}</td>
          </ng-container>

          <ng-container matColumnDef="valid_posts">
            <th mat-header-cell *matHeaderCellDef class="text-center font-semibold">Valid Posts</th>
            <td mat-cell *matCellDef="let element">
              <span class="text-green-600 font-medium">{{ element.valid_rows }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="post_details">
            <th mat-header-cell *matHeaderCellDef class="text-center font-semibold">Post List</th>
            <td mat-cell *matCellDef="let element" class="text-center">
              <button
                class="inline-flex items-center gap-1.5 text-sm text-gray-400 hover:text-indigo-400 transition-colors duration-200 tracking-wide"
                (click)="expandedElement = expandedElement === element ? null : element">
                <mat-icon class="!text-base !w-5 !h-5 transition-transform duration-200"
                  [class.rotate-180]="expandedErrorLogsElement === element">
                  keyboard_arrow_down
                </mat-icon>
                <span>{{ expandedElement === element ? 'collapse' : 'view posts' }}</span>
              </button>
            </td>
          </ng-container>

          <ng-container matColumnDef="invalid_posts">
            <th mat-header-cell *matHeaderCellDef class="text-left font-semibold">Invalid Posts</th>
            <td mat-cell *matCellDef="let element">
              <span class="text-red-600 font-medium">{{ element.failed_posts_count }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="error_details">
            <th mat-header-cell *matHeaderCellDef class="text-center font-semibold">Error List</th>
            <td mat-cell *matCellDef="let element" class="text-center">
              <button
                class="inline-flex items-center gap-1.5 text-sm text-gray-400 hover:text-rose-400 transition-colors duration-200 tracking-wide cursor-pointer"
                (click)="expandedErrorLogsElement = expandedErrorLogsElement === element ? null : element">
                <mat-icon class="!text-base !w-5 !h-5 transition-transform duration-200"
                  [class.rotate-180]="expandedErrorLogsElement === element">
                  keyboard_arrow_down
                </mat-icon>
                <span>{{ expandedErrorLogsElement === element ? 'collapse' : 'view errors' }}</span>
              </button>
            </td>
          </ng-container>

          <ng-container matColumnDef="created_at">
            <th mat-header-cell *matHeaderCellDef class="text-left font-semibold">Uploaded</th>
            <!-- <td mat-cell *matCellDef="let element">{{ element.created_at | date: 'dd/MM/yyyy HH:mm' }}</td> -->
           <td mat-cell *matCellDef="let element" class="text-gray-600">{{ element.created_at | date: 'dd/MM/yyyy HH:mm' }}</td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns" class="hover:bg-gray-100 transition-all"></tr>

          <!-- Expanded row: Posts -->
          <ng-container matColumnDef="expandedDetail">
            <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length">
              <div *ngIf="expandedElement === element" class="p-4 rounded-lg ">
                <h4 class="font-bold text-gray-700 mb-4">Posts</h4>

                <ng-container *ngIf="element.posts?.length; else noPosts">
                  <div *ngFor="let post of element.posts"
                    class="border border-gray-300 relative my-2 py-3 px-3 text-sm text-gray-800 rounded-md flex justify-between items-start hover:bg-gray-100 hover:shadow-sm transition-all">

                    <div class="grid grid-cols-2 md:grid-cols-3 gap-2 w-full pr-10">
                      <div><strong>Site:</strong> {{ post.content_site }}</div>
                      <div><strong>Category:</strong> {{ post.feed }}</div>
                      <div><strong>Title:</strong> {{ post.rss_title }}</div>
                      <div><strong>Tag:</strong> {{ post.tag }}</div>
                      <div><strong>Platform:</strong> {{ post.platform }}</div>
                      <div><strong>Week Day:</strong> {{ weekDays[post.week_day] }}</div>
                      <div><strong>Status:</strong> {{ post.post_status }}</div>
                      <div><strong>Scheduled:</strong> {{ post.scheduled_for | date:'dd/MM/yyyy HH:mm' }}</div>
                      <div><strong>Source:</strong> {{ post.source }}</div>
                    </div>

                    <button mat-icon-button color="primary" (click)="editRow(post)" matTooltip="Edit post"
                      class="absolute top-2 right-2">
                      <mat-icon>edit</mat-icon>
                    </button>
                  </div>
                </ng-container>

                <ng-template #noPosts>
                  <p class="text-gray-400 italic">No posts available.</p>
                </ng-template>
              </div>
            </td>
          </ng-container>

          <!-- Expanded row: Errors -->
          <ng-container matColumnDef="expandedLogs">
            <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length">
              <div *ngIf="expandedErrorLogsElement === element" class="p-4 rounded-lg">
                <h4 class="font-bold text-red-600 mb-2">Error Logs</h4>
                <ng-container *ngIf="element.failed_posts?.length; else noLogs">
                  <div *ngFor="let failed of element.failed_posts" class="border border-rose-100 bg-rose-50 relative my-2 py-3 px-3 text-sm text-gray-800 rounded-md hover:bg-red-100 hover:shadow-sm transition-all">
                    <div><strong>Row:</strong> {{ failed.row_number }}</div>
                    <div><strong>Message:</strong> {{ failed.error_messages.message }}</div>
                  </div>
                </ng-container>
                <ng-template #noLogs>
                  <p class="text-gray-400 italic">No error logs found.</p>
                </ng-template>
              </div>
            </td>
          </ng-container>

          <!-- Expanded rows -->
          <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="expanded-row"
            [class.hidden]="expandedElement !== row">
          </tr>

          <tr mat-row *matRowDef="let row; columns: ['expandedLogs']" class="expanded-row"
            [class.hidden]="expandedErrorLogsElement !== row">
          </tr>
        </mat-table>

        <div class="flex items-center justify-center gap-4 mt-6">
          <button
            (click)="gotToViewBulks()"
            class="px-6 py-3 bg-green-600 hover:bg-green-700 text-white font-semibold rounded-xl transition cursor-pointer">
            View Bulks
          </button>

          <button
            (click)="goToDashboard()"
            class="px-6 py-3 border border-gray-300 text-gray-700 hover:bg-gray-50 font-semibold rounded-xl transition cursor-pointer">
            Done
          </button>
        </div>
      </div>

      <app-footer-grid></app-footer-grid>
    </div>

    <div class="hidden 2xl:block col-span-12 2xl:col-span-3 h-full">
      <app-bulk-sidebar></app-bulk-sidebar>
    </div>
  </div>
</div>
